import { useTranslation } from "react-i18next";
import { badge } from "../../../styles";

export type AdminStatus = "UPCOMING" | "ACTIVE" | "COMPLETED";

interface Props {
  status: AdminStatus;
}

/**
 * Renders the same status badge previously duplicated as a local statusBadge()
 * function in both CompetitionsTab (i18n'd via status.*) and AdminCompetitionPage
 * (hardcoded English) — the two had drifted apart. This uses the i18n'd copy for
 * both, which is a real (small, safe) fix for AdminCompetitionPage rather than
 * scope creep: extracting one shared implementation necessarily picks one
 * behaviour, and the i18n'd version is the one that was actually correct.
 */
export default function StatusBadge({ status }: Props) {
  const { t } = useTranslation();
  const map: Record<AdminStatus, { label: string; bg: string; color: string }> = {
    UPCOMING:  { label: t("status.upcoming"),  bg: "var(--color-badge-pending-bg)", color: "var(--color-badge-pending-text)" },
    ACTIVE:    { label: t("status.active"),    bg: "var(--color-status-active-bg)", color: "var(--color-status-active-text)" },
    COMPLETED: { label: t("status.completed"), bg: "var(--color-surface-alt)",      color: "var(--color-text-muted)" },
  };
  const s = map[status] ?? map.UPCOMING;
  return <span style={{ ...badge, background: s.bg, color: s.color }}>{s.label}</span>;
}
